export default __webpack_public_path__ + "static/media/close.51b57459.svg";